import React, {
  useEffect,
} from "react";

import {
  Link,
} from "react-router-dom";

import {
  motion,
} from "framer-motion";

import {
  useSelector,
} from "react-redux";

import {
  FiMenu,
  FiExternalLink,
  FiPlus,
  FiGrid,
  FiUser,
  FiChevronDown,
} from "react-icons/fi";

import {
  MdOutlineRestaurantMenu,
} from "react-icons/md";

import {
  ToggleDark,
  ToggleLanguages,
} from "../../utils";

import {
  useStateContext,
} from "../../../context/ContextProvider";

import {
  useTranslation,
} from "react-i18next";

import {
  media,
} from "../../../server";

import AdminProfil
  from "../utils/AdminProfil";


function DashboardHeader() {
  const {
    user,
  } = useSelector(
    (state) =>
      state.Users
  );


  const {
    activeMenu,
    setActiveMenu,
    handleClick,
    isClicked,
    setScreenSize,
    screenSize,
  } = useStateContext();


  const {
    t,
  } = useTranslation();


  /* =====================================
      WINDOW SIZE
  ====================================== */

  useEffect(() => {

    const handleResize =
      () => {
        setScreenSize(
          window.innerWidth
        );
      };


    handleResize();


    window.addEventListener(
      "resize",
      handleResize
    );


    return () =>
      window.removeEventListener(
        "resize",
        handleResize
      );

  }, [
    setScreenSize,
  ]);


  /* =====================================
      SIDEBAR RESPONSIVE
  ====================================== */

  useEffect(() => {

    if (
      screenSize <= 900
    ) {
      setActiveMenu(false);
    } else {
      setActiveMenu(true);
    }

  }, [
    screenSize,
    setActiveMenu,
  ]);


  const avatarUrl =
    user?.avatar
      ? `${media}${user.avatar}`
      : null;


  return (
    <header
      className={`
        fixed

        top-0
        start-0

        z-50

        w-full

        transition-all
        duration-500

        ${
          activeMenu
            ? `
              lg:ltr:pl-[286px]
              lg:rtl:pr-[286px]
            `
            : ""
        }
      `}
    >

      <div
        className="
          h-[78px]

          flex
          items-center

          border-b
          border-color-2/10
          dark:border-white/10

          bg-back-primery/90
          dark:bg-back-darksecondary/90

          backdrop-blur-2xl

          shadow-[0_8px_35px_rgba(68,37,20,.06)]

          px-4
          md:px-7
        "
      >

        <div
          className="
            flex

            w-full

            items-center
            justify-between

            gap-4
          "
        >

          {/* =================================
              LEFT / START
          ================================= */}

          <div
            className="
              flex
              items-center

              gap-3
            "
          >

            {/* Menu */}

            <motion.button
              type="button"

              whileTap={{
                scale: 0.92,
              }}

              onClick={() =>
                setActiveMenu(
                  !activeMenu
                )
              }

              className="
                flex

                w-11
                h-11

                shrink-0

                items-center
                justify-center

                rounded-full

                border
                border-color-1/20

                bg-color-1/10

                text-color-1

                transition-all

                hover:bg-color-1
                hover:text-white
              "
            >
              <FiMenu
                size={20}
              />
            </motion.button>


            {/* Page Label */}

            <div
              className="
                hidden
                sm:block
              "
            >
              <h1
                className="
                  font-kufi
                  font-semibold

                  text-sm
                  md:text-base

                  text-tcolor-4
                  dark:text-white
                "
              >
                {t(
                  "Yaman Dashboard"
                )}
              </h1>


              <p
                className="
                  mt-0.5

                  font-kufi
                  text-[9px]
                  md:text-[10px]

                  text-n-5
                  dark:text-white/35
                "
              >
                {t(
                  "Manage restaurant content"
                )}
              </p>
            </div>

          </div>


          {/* =================================
              QUICK ACTIONS
          ================================= */}

          <div
            className="
              hidden
              xl:flex

              items-center

              gap-2
            "
          >

            <Link
              to="/CreateMealPage"

              className="
                group

                flex

                min-h-[42px]

                items-center

                gap-2

                rounded-full

                bg-color-1

                px-4

                font-kufi
                text-xs

                text-white

                transition-all

                hover:bg-color-2
              "
            >
              <FiPlus />

              {t(
                "Create Meal"
              )}
            </Link>


            <Link
              to="/DAllMealsPage"

              className="
                flex

                w-10
                h-10

                items-center
                justify-center

                rounded-full

                border
                border-color-2/10
                dark:border-white/10

                text-color-1

                transition-all

                hover:bg-color-1/10
              "
            >
              <MdOutlineRestaurantMenu />
            </Link>


            <Link
              to="/"

              target="_blank"

              className="
                flex

                w-10
                h-10

                items-center
                justify-center

                rounded-full

                border
                border-color-2/10
                dark:border-white/10

                text-color-1

                transition-all

                hover:bg-color-1/10
              "
            >
              <FiExternalLink />
            </Link>

          </div>


          {/* =================================
              END ACTIONS
          ================================= */}

          <div
            className="
              flex
              items-center

              gap-1
              sm:gap-2
            "
          >

            {/* Language */}

            <div
              className="
                hidden
                sm:flex

                items-center
                justify-center

                rounded-xl

                border
                border-color-2/10
                dark:border-white/10

                bg-color-2/5
                dark:bg-white/5

                p-1
              "
            >
              <ToggleLanguages />
            </div>


            {/* Dark */}

            <div
              className="
                hidden
                sm:flex

                items-center
                justify-center

                rounded-xl

                border
                border-color-2/10
                dark:border-white/10

                bg-color-2/5
                dark:bg-white/5

                p-1
              "
            >
              <ToggleDark />
            </div>


            {/* =================================
                PROFILE
            ================================= */}

            <div
              className="
                relative
              "
            >

              <button
                type="button"

                onClick={() =>
                  handleClick(
                    "userProfile"
                  )
                }

                className="
                  group

                  flex

                  items-center

                  gap-2

                  rounded-full

                  border
                  border-color-2/10
                  dark:border-white/10

                  bg-back-secondary
                  dark:bg-back-darkprimery

                  p-1.5
                  pe-2
                  sm:pe-3

                  transition-all

                  hover:border-color-1/40
                "
              >

                {/* Avatar */}

                <div
                  className="
                    flex

                    w-9
                    h-9

                    shrink-0

                    items-center
                    justify-center

                    overflow-hidden

                    rounded-full

                    bg-color-1/15

                    text-color-1
                  "
                >

                  {avatarUrl ? (

                    <img
                      src={
                        avatarUrl
                      }

                      alt={
                        user?.name ||
                        "Admin"
                      }

                      className="
                        w-full
                        h-full

                        object-cover
                      "
                    />

                  ) : (

                    <FiUser />

                  )}

                </div>


                {/* Name */}

                <div
                  className="
                    hidden
                    md:block

                    max-w-[130px]

                    text-start
                  "
                >

                  <span
                    className="
                      block

                      font-kufi
                      text-[9px]

                      text-n-5
                      dark:text-white/35
                    "
                  >
                    {t("Hi,")}
                  </span>


                  <span
                    className="
                      block

                      truncate

                      font-kufi
                      font-semibold

                      text-xs

                      text-tcolor-4
                      dark:text-white
                    "
                  >
                    {user?.name ||
                      t("Admin")}
                  </span>

                </div>


                <FiChevronDown
                  className="
                    hidden
                    md:block

                    text-color-1

                    transition-transform

                    group-hover:translate-y-0.5
                  "
                />

              </button>


              {isClicked
                ?.userProfile && (
                <AdminProfil />
              )}

            </div>

          </div>

        </div>

      </div>

    </header>
  );
}


export default DashboardHeader;